/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {


  function generateShopifySrcSet(originalUrl) {

    if (!originalUrl) return '';

    const widths = [1000, 200, 400, 256, 512, 275, 550, 350, 700];

    const urlParts = originalUrl.split('?');
    const base = urlParts[0];
    const query = urlParts[1] || '';

    const params = new URLSearchParams(query);

    return widths.map(width => {

      // Keep crop & v
      const crop = params.get('crop') || '';
      const v = params.get('v') || '';

      // Calculate proportional height (same ratio logic Shopify uses)
      const originalWidth = params.get('width') || 1000;
      const originalHeight = params.get('height') || 1000;

      const ratio = originalHeight / originalWidth;
      const newHeight = Math.round(width * ratio);

      return `${base}?crop=${crop}&height=${newHeight}&v=${v}&width=${width} ${width}w`;

    }).join(',\n');
  }
  document.addEventListener('mouseover', function (e) {
      if(document.querySelector('.template-product') ||  document.querySelector('.template-index') || document.querySelector('.variant-with-color') || document.querySelector('.default-with-color') || document.querySelector('.chupps-quiz')){
        const radioButton = e.target.closest('.radio__button');
        if (!radioButton) return;

        const label = radioButton.querySelector('label');
        if (!label) return;

        const firstImgUrl = label.dataset.first;
        const secondImgUrl = label.dataset.second;

        const productCard = radioButton.closest('.product-grid-item-outer');
        if (!productCard) return;

        // FIRST IMAGE
        if (firstImgUrl) {
          const img1 = productCard.querySelector('.product-grid-item__image-wrapper.first_0 img');
          if (img1) {
            img1.src = firstImgUrl;
            img1.srcset = generateShopifySrcSet(firstImgUrl);
          }
        }

        // SECOND IMAGE
        if (secondImgUrl) {
          const img2 = productCard.querySelector('.product-grid-item__image-wrapper.first_1 img');
          if (img2) {
            img2.src = secondImgUrl;
            img2.srcset = generateShopifySrcSet(secondImgUrl);
          }
        }
      } 
  });


  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();



document.querySelectorAll('.mobile_search_dropdown').forEach(el => {
  el.addEventListener('click', () => {
    document
      .querySelector('.navlink[data-popdown-toggle="search-popdown"]')
      ?.click();
  });
});